import type { CampaignAudience } from '@clarity/contract';

/**
 * Shared Terms-axis helpers (clarity-campaign-terms-economics) — the economic-
 * signature chips, the audience labels, and the three signature icons that BOTH
 * the Terms LIST ({@link TermsView}) and the Term DETAIL ({@link TermDetail})
 * render. Factored here so the two surfaces draw the same chips from one source
 * (the detail's header reuses the list card's signature chips verbatim), rather
 * than duplicating the icon SVGs + the audience map in each file.
 *
 * The icons are the mock's `scope2` / `cap2` / `aud` glyphs; every chip carries
 * TEXT alongside the glyph, so the signature reads without colour (WCAG 1.4.1).
 */

/** The human label for each campaign audience (the mock's audience chip copy). */
export const AUDIENCE_LABEL: Record<CampaignAudience, string> = {
  all: 'all customers',
  plus: 'Plus (TPRO) only',
  nonplus: 'non-Plus customers',
  new_customer: 'new customers',
};

export function ScopeIcon() {
  return (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1.5" />
      <path d="M11 7h5a2 2 0 0 1 2 2v4" strokeDasharray="2 2" />
    </svg>
  );
}

export function CapIcon() {
  return (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 15a8 8 0 0 1 16 0" />
      <path d="M2 15h20" />
      <path d="M12 7V4" />
    </svg>
  );
}

export function AudIcon() {
  return (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16 5a3 3 0 0 1 0 6M21 20a6 6 0 0 0-5-5.9" />
    </svg>
  );
}
